import { Button, Dialog, Layout, Panel } from "@mcleod/components";
import { StatusAddOrder } from "./StatusAddOrder";
import { HorizontalAlignment, StringUtil } from "@mcleod/core";

export class StatusAddOrderDialog extends Dialog {
    private _orderId: string;
    override async show(): Promise<any> {
        const layout = Layout.getLayout("lme/datafusion/StatusAddOrder") as StatusAddOrder;
        layout.orderId = this.orderId;
        const panelButtons = new Panel({ fillRow: true, align: HorizontalAlignment.CENTER, marginTop: 16 })
        const buttonContinue = new Button({ caption: "Continue", rowBreak: false, default: true, marginRight: 10, backgroundColor: "primary", color: "primary.reverse" });
        const buttonCancel = new Button({ caption: "Cancel", rowBreak: false, marginRight: 48 });
        let orderId = null;
        let partnerId = null;
        let altPartnerId = null;
        let version = null;
        buttonCancel.addClickListener(() => this.close(false));

        buttonContinue.addClickListener(_event => {
            if (!StringUtil.isEmptyString(layout.textboxOrderNumber.text)
                && !StringUtil.isEmptyString(layout.partnerId)
                && !StringUtil.isEmptyString(layout.altPartnerId)
                && !StringUtil.isEmptyString(layout.version)) {
                orderId = layout.textboxOrderNumber.text;
                partnerId = layout.partnerId;
                altPartnerId = layout.altPartnerId;
                version = layout.version;
                this.close(true);
            } else {
                layout.textboxOrderNumber.showAdhocTooltip("Please select an order before continuing.");
            }
        })

        panelButtons.add(buttonCancel);
        panelButtons.add(buttonContinue);

        layout.addLayoutLoadListener(() => {
            layout.insert(panelButtons, 4);
        });
        this.add(layout);

        await super.show();
        return Promise.resolve({ order_id: orderId, partner_id: partnerId, alt_partner_id: altPartnerId, version: version });
    }

    public get orderId(): string {
        return this._orderId;
    }

    public set orderId(value: string) {
        this._orderId = value;
    }
}
